import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"; // For Realtime Database
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth"; // For Auth
import { getFirestore } from "firebase/firestore"; // For Firestore

// Your Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDzJFoxsElrSfaOFP19jAzNFPOmWb49qwg",
  authDomain: "lmsdeployment.firebaseapp.com",
  databaseURL:
    "https://lmsdeployment-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "lmsdeployment",
  storageBucket: "lmsdeployment.appspot.com",
  messagingSenderId: "600234580254",
  appId: "1:600234580254:web:6ff7706863d66e1250d10f",
  measurementId: "G-WSY3C6TVM6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and Firestore
const db = getDatabase(app); // Realtime Database
const firestore = getFirestore(app); // Firestore Database

// Initialize Authentication and set persistence
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Persistence set to browser local storage.");
  })
  .catch((error) => {
    console.error("Error setting persistence:", error);
  });

export { db, firestore, auth };
